import { useContext, useEffect } from "react";
import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import OtpInput from "react-otp-input";
import { motion } from "framer-motion";

import { logo } from "../../../assets";
import { loginUserValidation } from "../../../utils/validation/validation";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import ValidationErrorMessage from "./../../../helpers/ValidationErrorMessage/ValidationErrorMessage";

import { authContext } from "../../../context/AuthContext/AuthContext";

import { HiEye, HiEyeOff } from "react-icons/hi";
import { MdInstallDesktop, MdInstallMobile } from "react-icons/md";

const SignIn = ({ changeFormPage, setChangeFormPage }) => {
  const {
    isShowPassLogin,
    setIsShowPassLogin,
    loginCode,
    setLoginCode,
    sendCode,
    handleLogIn,
    handleOtpCode,
    setDeferredPrompt,
    showInstallButton,
    setShowInstallButton,
    handleInstallClick,
  } = useContext(authContext);

  // PWA Installer
  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallButton(true);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);

  // Validation
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginUserValidation),
  });

  return (
    <>
      <SiteTitle title="ورود به حساب کاربری" />
      <motion.div
        initial={{ opacity: 0, rotateY: 180 }}
        animate={{
          opacity: 1,
          rotateY: 0,
          transition: {
            duration: 1,
          },
        }}
        className="2xl:w-3/12 xl:w-4/12 lg:w-5/12 md:w-6/12 sm:w-7/12
        w-10/12 py-5 flex flex-col bg-boxColor rounded-2xl"
      >
        <div className="flex items-center w-full px-6 mx-auto">
          <div className="flex-1">
            {/* Logo */}
            <div className="flex justify-center items-center mb-8">
              <img
                src={logo}
                alt="Website Logo"
                className="rounded-full bg-cover w-28 h-28"
              />
            </div>
            {/* Title */}
            <div className="text-center flex justify-center ">
              {sendCode ? (
                <h2
                  className="text-2xl font-bold text-center cursor-pointer
                  text-white"
                >
                  کد تأیید برای ورود
                </h2>
              ) : (
                <>
                  <h2
                    onClick={() => setChangeFormPage("signin")}
                    className={`text-2xl font-bold text-center cursor-pointer
                  hover:text-gray-300 ${
                    changeFormPage === "signin"
                      ? "text-green-500"
                      : "text-white"
                  }`}
                  >
                    ورود
                  </h2>
                  <span className="text-2xl font-bold text-center mx-3 text-white">
                    -
                  </span>
                  <h2
                    onClick={() => setChangeFormPage("signup")}
                    className="text-2xl font-bold text-center cursor-pointer
              hover:text-gray-300 text-white"
                  >
                    ثبت نام
                  </h2>
                </>
              )}
            </div>
            {/* Login Form */}
            <div className={`${sendCode ? "hidden" : "none"} mt-8`}>
              <form onSubmit={handleSubmit(handleLogIn)} className="space-y-6">
                {/* Phone Number  */}
                <div>
                  <label
                    htmlFor="phoneNumber"
                    className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                  >
                    شماره موبایل
                  </label>
                  <input
                    type="number"
                    name="phoneNumber"
                    placeholder="09123456789"
                    autoComplete="off"
                    {...register("phonenumber")}
                    className={`${sendCode ? "hidden" : "none border-gray-600"} 
                      block w-full px-4 py-2 mt-2 border rounded-md lg:text-md text-sm
                      placeholder-gray-600 bg-zinc-900 text-gray-400 
                      focus:border-gray-200 tracking-widest mb-2 text-left
                      focus:outline-none font-medium`}
                  />
                  <span>
                    <ValidationErrorMessage
                      message={errors.phonenumber?.message}
                    />
                  </span>
                </div>
                {/* Password */}
                <div className="relative">
                  <label
                    htmlFor="password"
                    className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                  >
                    رمز عبور
                  </label>
                  <input
                    type={isShowPassLogin ? "text" : "password"}
                    name="password"
                    placeholder="******"
                    autoComplete="off"
                    {...register("password")}
                    className={`${sendCode ? "hidden" : "none border-gray-600"} 
                      block w-full px-4 py-2 mt-2 border rounded-md
                      placeholder-gray-600 bg-zinc-900 text-gray-400 
                      focus:border-gray-200 tracking-widest mb-2 lg:text-md text-sm
                      focus:outline-none focus:text-gray-200 font-medium`}
                  />
                  {/* Show/Hide Password Icon */}
                  <span className="absolute left-2 top-10">
                    {isShowPassLogin ? (
                      <HiEye
                        onClick={() => setIsShowPassLogin(!isShowPassLogin)}
                        fill="#fff"
                        className="cursor-pointer"
                      />
                    ) : (
                      <HiEyeOff
                        onClick={() => setIsShowPassLogin(!isShowPassLogin)}
                        fill="#fff"
                        className="cursor-pointer"
                      />
                    )}
                  </span>
                  <span>
                    <ValidationErrorMessage
                      message={errors.password?.message}
                    />
                  </span>
                  {/* Forget Button */}
                  <span className="text-sm font-medium text-center text-slate-200 w-full">
                    <span
                      onClick={() => setChangeFormPage("forgetPassword")}
                      className="focus:outline-none flex justify-end ml-3 mt-3 cursor-pointer"
                    >
                      فراموشی رمز عبور
                    </span>
                  </span>
                </div>
                {/* Button */}
                <div>
                  <button
                    type="submit"
                    className="w-full px-4 py-2 tracking-wide text-white font-medium
                      transition-colors duration-200 transform rounded-md
                      bg-green-500 hover:bg-green-600 focus:outline-none"
                  >
                    دریافت کد
                  </button>
                </div>
              </form>
            </div>
            {/* Verify Code Part */}
            <div className={`${sendCode ? "none" : "hidden"} mt-8`}>
              <form onSubmit={handleSubmit(handleOtpCode)}>
                <div>
                  <label
                    htmlFor="verifyCode"
                    className="block mb-2 mr-2.5 text-sm font-medium text-gray-200"
                  >
                    کد تأیید
                  </label>
                  <span
                    className="flex justify-center items-center"
                    style={{ direction: "ltr" }}
                  >
                    <OtpInput
                      value={loginCode}
                      onChange={setLoginCode}
                      numInputs={5}
                      renderSeparator={<span>-</span>}
                      renderInput={(props) => (
                        <input
                          {...props}
                          type="number"
                          name="verifyCode"
                          autoComplete="off"
                          className="block w-full px5 py-2 my-4 mx-3 border rounded-md
                              placeholder-gray-600 bg-zinc-900 text-gray-400 text-center
                              border-gray-700 focus:border-gray-400 tracking-widest 
                                focus:outline-none focus:text-gray-200 font-medium"
                          style={{ direction: "rtl" }}
                        />
                      )}
                    />
                  </span>
                </div>
                <p className="text-center mt-2 text-gray-200">
                  زمان باقی مانده
                  <span id="verificationCodeCountDown" className="mx-2">
                    120
                  </span>
                  ثانیه
                </p>
                {/* Button */}
                <button
                  type="submit"
                  className="w-full px-4 py-2 mt-5 tracking-wide text-white font-medium
                    transition-colors duration-200 transform rounded-md
                    bg-green-500 hover:bg-green-600 focus:outline-none"
                >
                  ورود
                </button>
              </form>
            </div>
            {/* Pwa Button */}
            {!sendCode && (
              <div className="mt-6 text-sm font-medium text-center text-gray-400">
                {showInstallButton && (
                  <button
                    className="w-full py-3 tracking-wide text-white font-medium
                        transition-colors duration-200 transform rounded-md 
                        flex justify-center text-base
                       bg-yellow-500 hover:bg-yellow-400 focus:outline-none"
                    onClick={handleInstallClick}
                  >
                    <MdInstallDesktop
                      size={22}
                      className="lg:flex hidden mx-1"
                    />
                    <MdInstallMobile
                      size={22}
                      className="flex lg:hidden mx-1"
                    />
                    نسخه تحت وب
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default SignIn;
